export default __webpack_public_path__ + "static/media/Helm of Black Oblivion.5ad743fb.jpg";